exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".invite-card-img{width:50px;height:50px;background-position:center;background-size:cover;border-radius:50%;margin:auto}.invite-card-img{width:120px;height:120px;background-position:center;background-size:cover;border-radius:50%;margin-bottom:6px;margin-top:6px}.invite-card-container{border:1px solid #999;background:rgba(0,0,0,.8);padding:25px;margin-bottom:20px}.contacts-collapse-container{padding:10px;background:#000;border:1px solid;border-radius:30px}.invite-card-name h3{color:#febf00;font-size:38px;font-weight:bold;text-align:left}.invite-card-name-text{margin-top:6px}.contact-button-container{margin-bottom:10px;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ContactInviteCard/styles.scss
// module id = 795
// module chunks = 0